import { render, staticRenderFns } from "./Documento.vue?vue&type=template&id=690d53ee&scoped=true"
import script from "./Documento.vue?vue&type=script&lang=js"
export * from "./Documento.vue?vue&type=script&lang=js"
import style0 from "./Documento.vue?vue&type=style&index=0&id=690d53ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690d53ee",
  null
  
)

export default component.exports